import { createSlice } from "@reduxjs/toolkit";

export const certificadosSlice = createSlice({
  name: "certificados",
  initialState: {
    rtefuenteDB: [],
    rteicaDB: [],
    rteivaDB: [],
    periodosDB: [],
    ciudadesDB: [],
    yearsDB: [],
    tipocertificadoDB: [],
    loading: false,
  },
  reducers: {
    setrtefuente: (state, { payload }) => {
      state.rtefuenteDB = payload;
    },
    setrteica: (state, { payload }) => {
      state.rteicaDB = payload;
    },
    setrteiva: (state, { payload }) => {
      state.rteivaDB = payload;
    },
    setPeriodos: (state, { payload }) => {
      state.periodosDB = payload;
    },
    setCiudades: (state, { payload }) => {
      state.ciudadesDB = payload;
    },
    setTipocertificado: (state, { payload }) => {
      state.tipocertificadoDB = payload;
    },
    setYears: (state, { payload }) => {
      state.yearsDB = payload;
    },
    setLoadingCert: (state, { payload }) => {
      state.loading = payload;
    },
  },
});

export const {
  setrtefuente,
  setrteica,
  setrteiva,
  setPeriodos,
  setCiudades,
  setTipocertificado,
  setYears,
  setLoadingCert
} = certificadosSlice.actions;
